import { API, graphqlOperation } from 'aws-amplify';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateUser } from '../actions';
import { UpdateUserProfileMutation } from '../graphql/api';
import { updateUserProfile } from '../graphql/mutations';
import { IState } from '../graphql/types';

const useUserPreference = (id: string) => {
  const allPreferences = useSelector<IState, {} | undefined>(
    state => state.user?.preferences
  );
  const dispatch = useDispatch();

  const updatePreferenceRequest = React.useCallback(
    async (value: boolean | string) => {
      const result = await (API.graphql(
        graphqlOperation(updateUserProfile, {
          input: { preferences: { [id]: value } },
        })
      ) as Promise<{ data: UpdateUserProfileMutation }>);
      if (result.data.updateUserProfile) {
        dispatch(
          updateUser({
            preferences: { ...allPreferences, [id]: value },
          })
        );
      }
    },
    [allPreferences, dispatch, id]
  );

  const updatePreference = React.useCallback(
    async (value: boolean | string) => {
      try {
        await updatePreferenceRequest(value);
      } catch (e: any) {
        if (e.response?.data?.error?.code === 'ValidationException') {
          await (API.graphql(
            graphqlOperation(updateUserProfile, {
              input: { preferences: {} },
            })
          ) as Promise<{ data: UpdateUserProfileMutation }>);
          await updatePreferenceRequest(value);
        }
      }
    },
    [updatePreferenceRequest]
  );

  const preference =
    allPreferences === undefined ? undefined : allPreferences?.[id] || false;

  return { allPreferences, preference, updatePreference };
};

export default useUserPreference;
